module.exports = __webpack_public_path__ + "static/media/TransTowerIcon.e2944683.svg";